var React = require('react');
var UserStore = require('../../stores/UserStore');

var WelcomeHandler = React.createClass({
  componentWillMount: function () {
    var authenticated = !!UserStore.getUser();

    if (!authenticated) {
      window.location.href = _SIGNUP_BASE + '/';
      return;
    }

    window.location.href = _SIGNUP_BASE + '/login';
  },
  render: function () {
    return <p />;
  },
});
module.exports = WelcomeHandler;



// WEBPACK FOOTER //
// ./app/components/Signup/WelcomeHandler.js